// socket events
// they need to match the back-end values
export default {
  subscribeToOrder: 'subscribeToOrder',
  unsubscribeFromOrder: 'unsubscribeFromOrder',
  orderChanged: 'orderChanged',
  subscribeToOrderDoc: 'subscribeToOrderDoc',
  unsubscribeFromOrderDoc: 'unsubscribeFromOrderDoc',
  orderDocChanged: 'orderDocChanged',
  notificationReceived: 'notificationReceived',
  subscribeToOrderMessages: 'subscribeToOrderMessages',
  unsubscribeFromOrderMessages: 'unsubscribeFromOrderMessages',
  messageReceived: 'messageReceived',
  subscribeToUser: 'subscribeToUser',
  unsubscribeFromUser: 'unsubscribeFromUser',
  subscribeToUsers: 'subscribeToUsers',
  unsubscribeFromUsers: 'unsubscribeFromUsers',
  userActivityStatusChanged: 'userActivityStatusChanged',
  subscribeToOrderSigner: 'subscribeToOrderSigner',
  unsubscribeFromOrderSigner: 'unsubscribeFromOrderSigner',
  orderSignerActivityStatusChanged: 'orderSignerActivityStatusChanged',
  subscribeToVidReq: 'subscribeToVidReq',
  unsubscribeFromVidReq: 'unsubscribeFromVidReq',
  vidReqChanged: 'vidReqChanged',
  vidReqCreated: 'vidReqCreated',
  paymentStatusChanged: 'paymentStatusChanged',
  subscribeToPayment: 'subscribeToPayment',
  unsubscribeFromPayment: 'unsubscribeFromPayment',
}

export const socketEventResponse = {
  success: 1,
  error: 0,
}